import React, { useCallback, useState, useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  Box,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import ArrowBackIosTwoToneIcon from '@mui/icons-material/ArrowBackIosTwoTone';
import ReplyAllTwoToneIcon from '@mui/icons-material/ReplyAllTwoTone';
const Demographics = lazy(() => import("../Pages/Demographics"));
const InsurancePatient = lazy(() => import("../Pages/InsurancePatient")); // Ensure this file exists

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
};

const PatientRegistration = () => {
  const location = useLocation();
  const patientId = location.state?.patientId || null; // Retrieve patientId from state
  const [tabValue, setTabValue] = useState(0);
  const [patientData, setPatientData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("Thyra_Token");
 
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  // Fetch patient data when patientId is provided
  useEffect(() => {
    if (patientId) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Patient/getPatientById?Id=${patientId}`,
          { headers }
        )
        .then((response) => {
          setPatientData(response);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching patient data:", error);
          setIsLoading(false);
        });
    }
  }, [patientId]);

  const handleTabChange = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);
  const handleCancel = () => {
    
    navigate("/Patient"); // Navigate back to Patient list
  };
  return (
    <div className="page-content">
      <Container>
        
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", color: "#2B7B7E" }}
          >
            Patient Registration
          </Typography>
        
        </Box>
        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress />
            
          </Box>
          
        ) : (
          
          <Card sx={{ backgroundColor: "#F5F7F9", color: "#2B7B7E", my: 4 }}>
            
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignContent: "center",
                flexWrap: "wrap",
                
              }}
            >
               <ReplyAllTwoToneIcon  onClick={handleCancel}/>
              <Typography variant="body1" sx={{ mr: 2 }}>
                <strong>ID:</strong> {patientData?.id || "N/A"}
              </Typography>
              <Typography variant="body1" sx={{ mr: 2 }}>
                {patientData
                  ? `${patientData.lastName}, ${patientData.firstName}`
                  : "N/A"}
              </Typography>
              <Typography variant="body1" sx={{ mr: 2 }}>
                <strong>DOB:</strong>{" "}
                {patientData?.dob
                  ? dayjs(patientData.dob).format("MM/DD/YYYY")
                  : "N/A"}
              </Typography>
              <Typography variant="body1">
                <strong>Gender:</strong> {patientData?.gender || "N/A"}
              </Typography>
            </CardContent>
          </Card>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            bgcolor: "background.paper",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Tab label="Demographics" />
            <Tab label="Insurance" />
            {/* <Tab label="Documents/Images" />
            <Tab label="Authorization" /> */}
          </Tabs>
        </Box>

        <Box sx={{ marginTop: "-80px", bgcolor: "background.default" }}>
          <Suspense fallback={<Typography>Loading...</Typography>}>
            <TabPanel value={tabValue} index={0}>
              <Demographics patientId={patientId} />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <InsurancePatient patientId={patientId} />
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <Typography>Documents/Images Content</Typography>
            </TabPanel>
            <TabPanel value={tabValue} index={3}>
              <Typography>Authorization Content</Typography>
            </TabPanel>
          </Suspense>
        </Box>
      </Container>
    </div>
  );
};

export default PatientRegistration;
